<div class="profile-wrap">
    <div class="container-main">
        <div class="profile">
            <h1>Your profile</h1>
            <div class="top-profile d-flex">
                <div class="profile-text" [ngClass]="{ 'pb-0': areAllStepsCompleted(steps) }">
                    <h2>{{ this.headText }}{{ userName() }}<span *ngIf="!areAllStepsCompleted(steps)">,</span></h2>
                    <p *ngIf="!areAllStepsCompleted(steps)" [innerHTML]="this.text"></p>
                </div>
                <div class="profile-img" *ngIf="!areAllStepsCompleted(steps)">
                    <img
                        class="img-profile"
                        *ngIf="this.currentUser?.currentApplication !== null"
                        src="assets/fqimages/user-profile.png"
                        alt="profile"
                    />
                    <img *ngIf="this.currentUser?.currentApplication === null" src="assets/fqimages/user-profile.svg" alt="profile" />
                </div>
            </div>
            <div *ngIf="isLoading" class="loading-overlay">
                <div class="spinner"></div>
            </div>
            <div class="profile-section" *ngIf="!isLoading">
                <div class="profile-tab" *ngFor="let step of steps; let i = index">
                    <div
                        class="profile-box d-flex"
                        [class.profile-box-full]="step.children.length > 0"
                        [ngClass]="{
                            'fully-completed': (visibleStates[i] && isStepFullyCompleted(i)),
                        }"
                    >
                        <div
                            class="profile-box-main d-flex"
                            (click)="toggleVisibility(i)"
                            [ngClass]="step.status"
                            [class.hide-content]="visibleStates[i]"
                        >
                            <div class="line-bar" *ngIf="step.children.length <= 0">
                                <div class="line-percentange" [ngStyle]="{ width: step.percentage + '%' }"></div>
                            </div>
                            <div class="profile-inner" *ngIf="step.children.length <= 0">
                                <img [src]="'assets/fqimages/' + step.imagePath" alt="{{ step.stepTitle }}" />
                            </div>
                            <div class="prof-box-info" *ngIf="step.children.length <= 0">
                                <p class="time">{{ step.minute }} mins</p>
                                <h3>{{ step.title }}</h3>
                                <p>{{ step.description }}</p>
                                <a class="link-btn" [ngClass]="step.status" (click)="start(step.stepTitle)">{{ step.buttonText }}</a>
                            </div>
                            <div class="lock-num" *ngIf="step.children.length <= 0">
                                <h5>{{ i + 1 }}</h5>
                            </div>
                            <div class="line-bar" *ngIf="step.children.length > 0">
                                <div class="line-percentange" [ngStyle]="{ width: step.percentage + '%' }"></div>
                            </div>
                            <div class="profile-inner" *ngIf="step.children.length > 0">
                                <img src="assets/fqimages/financial-snapshot.svg" alt="about-you" />
                            </div>
                            <div class="prof-main-inner" *ngIf="step.children.length > 0">
                                <div class="prof-box-info">
                                    <p class="time">{{ step.minute }} mins</p>
                                    <h3>{{ step.title }}</h3>
                                    <p>{{ step.description }}</p>
                                </div>
                                <div
                                    *ngIf="step.children.length > 0 && !visibleStates[i] && isFinancialFullyCompleted(i, step)"
                                    class="financial-review"
                                >
                                    <a class="review-btn btn-full" (click)="start(step.stepTitle, 'Financial Snapshot')">
                                        Review Financial snapshot
                                    </a>
                                </div>
                                <div
                                    class="financial-col"
                                    [ngClass]="{
                                    'remove-flex': (visibleStates[i] && isFullyCompleted(i, step)) || (visibleStates[i] && isFinancialFullyCompleted(i, step)) || (visibleStates[i] && isWealthandRiskCompleted(i,step)),
                                }"
                                >
                                    <div
                                        class="financial-inner d-flex"
                                        *ngFor="let child of step.children"
                                        [ngClass]="{
                                        'remove-bottom': (visibleStates[i] && isFullyCompleted(i, step)) || (visibleStates[i] && isFinancialFullyCompleted(i, step)) || (visibleStates[i] && isWealthandRiskCompleted(i,step)),
                                    }"
                                    >
                                        <div class="profile-box-col d-flex overlay-dark" [ngClass]="child.status">
                                            <div class="line-bar">
                                                <div class="line-percentange" [ngStyle]="{ width: child.percentage + '%' }"></div>
                                            </div>
                                            <div class="prof-main-inner">
                                                <div class="prof-box-info">
                                                    <div class="income-text d-flex">
                                                        <h3>{{ child.title }}</h3>
                                                        <p class="time">{{ child.minute }} mins</p>
                                                    </div>
                                                    <a
                                                        class="link-btn btn-sm"
                                                        [ngClass]="child.status"
                                                        (click)="start(step.stepTitle, child.stepTitle)"
                                                        >{{ child.buttonText }}</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="review-col">
                                            <a class="review-btn" (click)="start(step.stepTitle, child.stepTitle)">
                                                Review {{ child.title }}</a
                                            >
                                        </div>
                                    </div>
                                    <div class="financial-col">
                                        <div class="review-col">
                                            <a class="review-btn btn-full" (click)="start(step.stepTitle, 'Financial Snapshot')">
                                                Review Financial snapshot
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="lock-num" *ngIf="step.children.length > 0">
                                    <h5>{{ i + 1 }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile-tab" style="width: 100% !important; margin-top: 20px !important">
                    <div class="profile-box profile-box-last">
                        <div class="profile-box-main d-flex">
                            <div class="profile-inner">
                                <img src="assets/fqimages/action.svg" alt="about-you" />
                            </div>
                            <div class="prof-box-info">
                                <p>Next step</p>
                                <h3>Enjoy your Financial Clarity Call, where your adviser will:</h3>
                                <ul class="list-text">
                                    <li>Help you understand your current situation</li>
                                    <li>Explore strategies that may be relevant for you</li>
                                    <li>Discuss your next steps</li>
                                </ul>
                                <div class="plan-btn-wrap">
                                    <a
                                        class="link-btn btn-sm get-my-plan"
                                        *ngIf="
                                            (isAllStepsCompleted || areAllStepsCompleted(steps)) &&
                                            !(isFileNotes || isDashboardApp) &&
                                            this.currentUser?.currentSubscription === null
                                        "
                                        (click)="getMyPlan()"
                                        >Get my plan! <img src="assets/fqimages/arrow-right.svg"
                                    /></a>
                                </div>

                                <div class="btn-grp">
                                    <button
                                        *ngIf="showStep(ApplicationStep.FinancialProjection)"
                                        class="step-btn btn-sm"
                                        (click)="start(ApplicationStep.FinancialProjection, null)"
                                    >
                                        Financial Projection
                                    </button>

                                    <button
                                        *ngIf="showStep(ApplicationStep.WealthStrategyOptions) && this.showDashandwealth"
                                        class="step-btn btn-sm"
                                        (click)="start(ApplicationStep.WealthStrategyOptions)"
                                    >
                                        Wealth Strategy Options
                                    </button>

                                    <button
                                        *ngIf="showStep(ApplicationStep.WealthCoach)"
                                        class="step-btn btn-sm"
                                        (click)="start(ApplicationStep.WealthCoach)"
                                    >
                                        Financial Adviser
                                    </button>

                                    <button
                                        *ngIf="showStep(ApplicationStep.Dashboard) && this.showDashandwealth"
                                        class="step-btn btn-sm"
                                        (click)="start(ApplicationStep.Dashboard)"
                                    >
                                        Dashboard
                                    </button>
                                </div>
                                <div class="note">
                                    <p>
                                        Note: You should have a Calendar invite for this call-please contact
                                        <a  class="email"
                                            href="mailto:support@wealthmaximiser.com.au"
                                        >
                                        support@wealthmaximiser.com.au
                                        </a>
                                        if not
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
